module.exports = __webpack_public_path__ + "static/img/friends-invitation-bg.6a0fdc0.png";